var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M16,.4V9.733a.287.287,0,0,1-.267.267H15.6c-.133,0-.133,0-.267-.133L12,6.533V9.067c0,.267-.133.4-.267.667a1.43,1.43,0,0,1-.8.267H1.067A1.018,1.018,0,0,1,.4,9.733c-.267-.267-.4-.4-.4-.667v-8A1.018,1.018,0,0,1,.267.4a.95.95,0,0,1,.8-.4h10a1.018,1.018,0,0,1,.667.267,1.9,1.9,0,0,1,.267.8V3.6L15.467.133C15.467,0,15.6,0,15.733,0,15.867.133,16,.133,16,.4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoWhite);
export default __webpack_public_path__ + "static/media/icon_video_white.e22bde26d02874e70ad937343b9c96d1.svg";
export { ForwardRef as ReactComponent };